import React, { useEffect, useState } from 'react';
import '../styles/animations.css';

export default function BudBurstAnimation({ points, onComplete }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 12 }, (_, i) => ({
      id: i,
      angle: (i / 12) * 360,
      delay: Math.random() * 0.3,
      distance: 60 + Math.random() * 40,
    }));
    setParticles(newParticles);

    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 1800);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="bud-burst-overlay">
      {particles.map(p => (
        <div
          key={p.id}
          className="bud-burst-particle"
          style={{
            transform: `translate(${Math.cos(p.angle * Math.PI / 180) * p.distance}px, ${Math.sin(p.angle * Math.PI / 180) * p.distance}px)`,
            animationDelay: `${p.delay}s`,
            background: p.id % 3 === 0 ? '#68d391' : p.id % 3 === 1 ? '#48bb78' : '#38a169',
          }}
        />
      ))}
      <div className="bud-burst-text">+{points} BP</div>
    </div>
  );
}
